export const svgs = {
    top: `
        <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 19">
            <path d="M6.339,17.956 L6.339,4.042 L2.023,8.426 C1.555,8.902 0.804,8.902 0.381,8.426 C-0.088,7.949 -0.088,7.188 0.381,6.758 L6.667,0.325 C6.900,0.087 7.229,-0.009 7.510,-0.009 C7.792,-0.009 8.120,0.087 8.354,0.325 L14.639,6.710 C15.107,7.188 15.107,7.949 14.639,8.378 C14.170,8.854 13.419,8.854 12.998,8.378 L8.682,3.994 L8.682,17.907 C8.682,18.528 8.167,19.004 7.510,19.004 C6.854,19.004 6.339,18.575 6.339,17.956 Z"/>
        </svg>
    `,
    bottom: `
        <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 19">
          <g transform="rotate(180) translate(-15, -19)">
            <path d="M6.339,17.956 L6.339,4.042 L2.023,8.426 C1.555,8.902 0.804,8.902 0.381,8.426 C-0.088,7.949 -0.088,7.188 0.381,6.758 L6.667,0.325 C6.900,0.087 7.229,-0.009 7.510,-0.009 C7.792,-0.009 8.120,0.087 8.354,0.325 L14.639,6.710 C15.107,7.188 15.107,7.949 14.639,8.378 C14.170,8.854 13.419,8.854 12.998,8.378 L8.682,3.994 L8.682,17.907 C8.682,18.528 8.167,19.004 7.510,19.004 C6.854,19.004 6.339,18.575 6.339,17.956 Z"/>
          </g>
        </svg>
    `,
    prev: `
        <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 19 16">
            <path d="M17.957,8.677 L4.041,8.677 L8.426,13.000 C8.902,13.470 8.902,14.222 8.426,14.646 C7.948,15.116 7.187,15.116 6.757,14.646 L0.325,8.348 C0.086,8.113 -0.008,7.784 -0.008,7.502 C-0.008,7.220 0.086,6.891 0.325,6.656 L6.710,0.358 C7.187,-0.111 7.948,-0.111 8.378,0.358 C8.854,0.828 8.854,1.580 8.378,2.003 L3.994,6.327 L17.907,6.327 C18.527,6.327 19.003,6.844 19.003,7.502 C19.003,8.160 18.575,8.677 17.957,8.677 Z"/>
        </svg>
    `,
    next: `
        <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 19 16">
            <path d="M1.038,8.677 L14.951,8.677 L10.568,13.000 C10.092,13.470 10.092,14.222 10.568,14.646 C11.043,15.116 11.808,15.116 12.236,14.646 L18.669,8.348 C18.906,8.113 19.002,7.783 19.002,7.502 C19.002,7.220 18.906,6.891 18.669,6.656 L12.283,0.358 C11.808,-0.112 11.043,-0.112 10.616,0.358 C10.139,0.829 10.139,1.580 10.616,2.003 L14.999,6.327 L1.085,6.327 C0.467,6.327 -0.011,6.844 -0.011,7.502 C-0.011,8.160 0.418,8.677 1.038,8.677 Z"/>
        </svg>
    `,
    play: `
        <svg xmlns="http://www.w3.org/2000/svg" width="512px" height="512px" viewBox="0 0 373.008 373.008">
            <path d="M61.792,2.588C64.771,0.864,68.105,0,71.444,0c3.33,0,6.663,0.864,9.655,2.588l230.116,167.2    c5.963,3.445,9.656,9.823,9.656,16.719c0,6.895-3.683,13.272-9.656,16.713L81.099,370.427c-5.972,3.441-13.334,3.441-19.302,0    c-5.973-3.453-9.66-9.833-9.66-16.724V19.305C52.137,12.413,55.818,6.036,61.792,2.588z" fill="#fff"/>
        </svg>
    `
}

export class ButtonElements {

    constructor( h, icon, text, classes = '' ) {
        this.h = h
        this.icon = icon
        this.text = text
        this.clasess = classes
    }

    get BtnIcon() {
        const { html, classes } = this.icon

        return this.render(html, classes)
    }

    get BtnText() {
        const { html, classes } = this.text

        return this.render(html, classes)
    }

    render(html, classes = '') {
        if ( !html || typeof this.h !== 'function' ) {
            return;
        }
        return this.h('span', {
            class: classes,
            domProps: {
                innerHTML: html
            }
        })
    }
}